import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ModalInclusionProcessToolNationalComponent,
  SegmentType,
} from '../modal-inclusion-process-tool-national/modal-inclusion-process-tool-national.component';
import { InclusionProcessToolNational } from '../../../../../../shared/interfaces/nt-inclusion-process-tool';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { DataService } from '../../../../../../services/dashboard/data.service';

@Component({
  selector: 'app-inclusion-process-tool-national',
  standalone: true,
  imports: [CommonModule, ModalInclusionProcessToolNationalComponent],
  templateUrl: './inclusion-process-tool-national.component.html',
  styleUrl: './inclusion-process-tool-national.component.css',
})
export class InclusionProcessToolNationalComponent implements OnInit {
  isModalOpen = false;
  activeSegment: SegmentType = 'openToAccess';
  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;
  summaryData: InclusionProcessToolNational | null = null;

  

constructor(private us: DmtUtilityService, private dataService: DataService) { }

ngOnInit(): void {
    this.getSessionVariables();
    this.loadData();
  }
 loadData(): void {
    this.dataService.getInclusionProcessSummary(this.medicineId, this.countryId).subscribe((data) => {
      this.summaryData = data;
    });
  }


  openModal(segment: SegmentType): void {
    this.activeSegment = segment;
    this.isModalOpen = true;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  }
 
  closeModal(): void {
    this.isModalOpen = false;
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  getSessionVariables(): void { 
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
  }
}
